function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import { Skeleton } from 'antd';
import { getClassNames } from '../../utils/getClassNames';
export var PageHeader = /*#__PURE__*/function (_React$PureComponent) {
  function PageHeader() {
    _classCallCheck(this, PageHeader);
    return _callSuper(this, PageHeader, arguments);
  }
  _inherits(PageHeader, _React$PureComponent);
  return _createClass(PageHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$onTitleSe, _this$props;
      (_this$props$onTitleSe = (_this$props = this.props).onTitleSet) === null || _this$props$onTitleSe === void 0 ? void 0 : _this$props$onTitleSe.call(_this$props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.title !== this.props.title) {
        var _this$props$onTitleSe2, _this$props2;
        (_this$props$onTitleSe2 = (_this$props2 = this.props).onTitleSet) === null || _this$props$onTitleSe2 === void 0 ? void 0 : _this$props$onTitleSe2.call(_this$props2);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: getClassNames('page-header', {
          loading: this.props.loading
        })
      }, /*#__PURE__*/React.createElement(Skeleton, _extends({
        title: false,
        paragraph: {
          rows: 2
        },
        active: true
      }, this.props.loaderConfig || {}, {
        loading: this.props.loading
      }), /*#__PURE__*/React.createElement("div", {
        className: getClassNames('page-header-wrapper')
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassNames('page-header-title')
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassNames('page-header-title-wrapper')
      }, /*#__PURE__*/React.createElement("h2", null, this.props.title), !!this.props.append && /*#__PURE__*/React.createElement("div", {
        className: getClassNames('page-header-title-append')
      }, this.props.append))), !!this.props.action && /*#__PURE__*/React.createElement("div", {
        className: getClassNames('page-header-action')
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassNames('page-header-action-wrapper')
      }, this.props.action)))));
    }
  }]);
}(React.PureComponent);